var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-search-field',{attrs:{"disabled":_vm.disabled,"list":_vm.aggOperatorList,"is-multiple":false,"value":_vm.aggOperator,"name":"aggOperator"},on:{"change":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }